@if (menuService.isReadOnly) {
  @if ($any(props.options) | async; as options) {
    {{ getValue($any(options)) }}
  }
} @else {
  <div class="input-group mb-3">
    <ng-select
      i18n-placeholder
      placeholder="Please select..."
      bindValue="value"
      bindLabel="label"
      class="form-control {{ props.cssClass }}"
      [items]="$any(props.options) | async"
      [multiple]="!!props.multiple"
      [appendTo]="appendTo"
      [closeOnSelect]="!props.multiple"
      [formControl]="$any(formControl)"
      [formlyAttributes]="field"
      [class.is-valid]="valid"
      [class.is-invalid]="invalid"
      (change)="onChange($event)"
    ></ng-select>
    @if (showCreate) {
      <button type="button" class="btn btn-light" (click)="onCreate($event)">
        <i class="fa fa-plus"></i>
      </button>
    }
    @if (showUpdate) {
      <button type="button" class="btn btn-light" (click)="onUpdate($event)">
        <i class="fa fa-pen"></i>
      </button>
    }
    @if (showDelete) {
      <button type="button" class="btn btn-light" (click)="onDelete($event)">
        <i class="fa fa-trash-alt"></i>
      </button>
    }
  </div>
}
